import Layout from '@/pages/Layout.vue'

import Dashboard from '@/pages/Dashboard.vue'

import Route404 from '@/pages/404.vue'

const routes = [
	{
		path: '/',
		component: Layout,
		redirect: "dashboard",
		children: [
			{
				path: 'dashboard',
				component: Dashboard,
			}
		]
	},
	{
		path: '*',
		component: Route404
	},

]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js